import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import { Link } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import PersonalDetailsIcon from "../assets/img/personal-details-icon.png";
import "../assets/css/candidate-tab-form.css";
import "../assets/css/inner-tabs.css";
import TickIconBlack from "../assets/img/tick-icon-black.png";
import CrossIcon from "../assets/img/cross-icon.png";
import UploadIcon from "../assets/img/upload-icon.svg";
import ArrowRightIcon from "../assets/img/arrow-right-icon.png";
import MainForm from "./AddressForm/MainForm";
import { getData } from "../Actions/landingAction";
import Footer from './Footer.js';
import StepCount from "./Common/StepCount";
import {
  validateAlphabetsAndNumeric,
  validateAlphabetsAndSpace,
  validatePincode,
} from "../Helper/common";

import Loader from './Common/loader';
import CandidateTabClient from "./CandidateTabClient";
import QuestionForm from './AddressForm/QuestionForm';

import { useNavigate, useHistory } from "react-router-dom";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";

import {
  useParams,
} from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { getAddress, updateQuestionAddress, addAddress, addNewAddress, deleteAddNewAddress } from '../Actions/addressActions';

import GetMasterData from "../Helper/masterData";
import NewAddressForm from "./AddressForm/NewAddressForm.js";
import ProgressHeading from "./Common/ProgressHeading.jsx";


const Address = () => {

  let { activeTab, reference } = useParams();

  const navigate = useNavigate();

  // alert(activeTab);

  const dispatch = useDispatch();
  const [address, setAddress] = useState([]);
  const [showQuestion, setShowQuestion] = useState();
  const [questionTitle, setQuestionTitle] = useState();
  const [showPermanentQues, setShowPermanentQues] = useState();
  const [showProfilePreview, setShowProfilePreview] = useState();
  const [role,setRole]=useState();

  const [showPermanentQuesOptions, setShowPermanentQuesOptions] = useState();

  const { countryOptions } = GetMasterData();
  const [countries, setCountry] = useState({});
  const [unsavedAddData, setUnsavedAddData] = useState({});
  const [showAddPopup, setShowAddPopup] = useState(false);

  const [lastRecordData, setLastRecordData] = useState(null);
  const [isAddFlag, setIsAddFlag] = useState(false);
  const [isDeleteFlag, setIsDeleteFlag] = useState(false);
  const [isActive, setIsActive] = useState();

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    window.scrollTo(0, 0)

    return()=>{
      setIsActive('');
    }
  }, []);


  //loading form fields information with get address api
  useEffect(() => {
    const fetchData = async () => {

      dispatch(getAddress());
    };

    fetchData();
  }, []);

  const [isLoading, setIsLoading] = useState(false);


  //fetching get field data from store
  const storeData = useSelector((state) => state.address);
  const { addressData, loading } = storeData;

  useEffect(() => {
    if (typeof loading !== "undefined" && loading !== null) {
      if (loading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }
    }
  }, [addressData]);


  useEffect(() => {
    if (
      typeof addressData.data !== "undefined" &&
      addressData.data !== null
    ) {


      if (Object.keys(unsavedAddData).length == 0) {
        setAddress(addressData.data.data);
      } else {
        const updatedData = addressData.data.data;
        let newData = _.cloneDeep(unsavedAddData);
        let checksDetailsMain = _.cloneDeep(newData.checksDetails);
        let updatedChecksDetails = _.cloneDeep(updatedData.checksDetails);
        const checksDetailsMainLength = checksDetailsMain.length || Object.keys(checksDetailsMain || {})?.length;
        const updatedChecksDetailsLength = updatedChecksDetails.length || Object.keys(updatedChecksDetails || {})?.length;
        if (checksDetailsMainLength == updatedChecksDetailsLength) {
          for (var i in checksDetailsMain) {
            if (typeof checksDetailsMain !== 'undefined'){
            checksDetailsMain[i]["uploaded_documents"] = updatedChecksDetails[i]
              .uploaded_documents
              ? updatedChecksDetails[i].uploaded_documents
              : [];
            checksDetailsMain[i]["uploaded_instant_documents"] =
              updatedChecksDetails[i].uploaded_instant_documents
                ? updatedChecksDetails[i].uploaded_instant_documents
                : [];
            }
          }
        } else if (updatedChecksDetailsLength > checksDetailsMainLength) {
          checksDetailsMain.push(
            updatedChecksDetails[updatedChecksDetailsLength - 1]
          );
        } else {
          let checkToBeRemovedIndex = null;
          for (let i = 0; i < checksDetailsMain.length; i++) {
            let isCheckPresent = false;
            for (let j = 0; j < updatedChecksDetails.length; j++) {
              if (
                checksDetailsMain[i].case_check_id ==
                updatedChecksDetails[j].case_check_id
              ) {
                isCheckPresent = true;
                break;
              }
            }
            if (!isCheckPresent) {
              checkToBeRemovedIndex = i;
            }
          }
          if (checkToBeRemovedIndex) {
            let newChecksDetails = [];
            for (let i = 0; i < checksDetailsMain.length; i++) {
              if (i != checkToBeRemovedIndex) {
                newChecksDetails.push(checksDetailsMain[i]);
              }
            }
            checksDetailsMain = _.cloneDeep(newChecksDetails);
          }
        }

        newData.checksDetails = _.cloneDeep(checksDetailsMain);
        setAddress(newData);
      }




      // setAddress(addressData.data.data);
      setShowPermanentQues(addressData.data.data.showPermanentQues);
      setShowPermanentQuesOptions(addressData.data.data.tempChecksArray)
      setShowQuestion(addressData.data.data.addresspopupshow);
      setQuestionTitle(addressData.data.data.popup_question);
      setShowProfilePreview(addressData.data.data.showProfilePreview);
      if(activeTab){
        setIsActive(activeTab);
      }else{
        setIsActive(addressData?.data?.data?.checksDetails?.[0]?.case_check_id);
      }
      
      // setShowQuestion(1);
    }
  }, [addressData, storeData]);

  console.log("sd" + showPermanentQues);


  const questionStausHandler = (record) => {
    // alert(JSON.stringify(record.campusHire));
    dispatch(updateQuestionAddress(record.value));
    setShowQuestion(record.value);
  

    //setCampusHire(record.campusHire);

  }


  //fetching get field data from store
  const addressUpdateQuestioStoreData = useSelector((state) => state.addressUpdateQuestion);
  const { addressUpdateQuestionData, loading: addressUpdateLoading } = addressUpdateQuestioStoreData;

  useEffect(() => {
    if (
      typeof addressUpdateQuestionData.status !== "undefined" &&
      addressUpdateQuestionData.status !== null
    ) {
      reSetData();

      reRenderAgain2();
    }
  }, [addressUpdateQuestionData, addressUpdateQuestioStoreData]);



  const reRenderAgain = (value) => {

    setUnsavedAddData(value);
    dispatch(getAddress());
  }

  const reRenderAgain2 = (value) => {
    // setUnsavedEmpData(value);
    dispatch(getAddress());
  }


  const reSetData = (value) => {
    // setUnsavedEmpData(value);
    setUnsavedAddData({});
  }





  //Handling Form Reference
  const form = useRef();

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    addressYesNo: null,
    houseNumber: null,
    colony: null,
    landMark: null,
    policeStation: null,
    pinCode: null,
    city: null,
    state: null,
    documentType: null,
  });

  //Handling Floating Labels
  const handleFloatingLabels = (e) => {
    {
      /* switch (e.target.name) {
      case "houseNumber":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: !validateAlphabetsAndNumeric(e.target.value),
        }));
        break;

        case "colony":
          setErrorData((prevState) => ({
            ...prevState,
            [e.target.name]: !validateAlphabetsAndSpace(e.target.value),
          }));
          break;

          case "landMark":
            setErrorData((prevState) => ({
              ...prevState,
              [e.target.name]: !validateAlphabetsAndSpace(e.target.value),
            }));
            break;

            case "policeStation":
              setErrorData((prevState) => ({
                ...prevState,
                [e.target.name]: !validateAlphabetsAndSpace(e.target.value),
              }));
              break;

              case "pinCode":
                setErrorData((prevState) => ({
                  ...prevState,
                  [e.target.name]: !validatePincode(e.target.value),
                }));
                break;

                case "city":
                  setErrorData((prevState) => ({
                    ...prevState,
                    [e.target.name]: !validateAlphabetsAndSpace(e.target.value),
                  }));
                  break;

                  case "state":
                    setErrorData((prevState) => ({
                      ...prevState,
                      [e.target.name]: !validateAlphabetsAndSpace(e.target.value),
                    }));
                  break;  */
    }

    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const mapAnArrayWithTwoDivisions = (data) => {
    const mappingData = Object.keys(data).reduce(function (rows, key, index) {
      return (
        (index % 2 == 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) &&
        rows
      );
    }, []);

    return mappingData;
  };



  const handleAddressAddClick = (e) => {
    e.preventDefault();
    handleAddPopup();
  };

  const handleAddPopup = () => {
    setShowAddPopup(true);
  }; 

  const closeAddPopup = () => {
    setShowAddPopup(false);
  };

  const proceedAdd = () => {
   
    dispatch(addAddress(lastRecordData,addCheckCallback));
    // setLastRecordData(null);
    setShowAddPopup(false);
  };

  const proceedAddPostValidation = (record, saveCallback=()=>{}) => {   
    // dispatch(addNewAddress(addSaveCheckCallback, saveCallback));
    dispatch(addNewAddress(saveCallback, ()=> {}, record));
    // setLastRecordData(null);
    setShowAddPopup(false);
  };

  const addCheckCallback = () => {
    setIsAddFlag(true);
    setIsDeleteFlag(false);
  }

  const deleteCheckCallback = (data) => {
    if(data && data?.completed){
      setIsDeleteFlag(true);
    }
    setIsAddFlag(false);
    let index = getPrevTab(data?.case_check_id);
    navigate(
      `/case-initiation/check-detail/${reference}/2/${addressData?.data?.data?.checksDetails?.[index-1]?.case_check_id}`
    );
    setIsActive(addressData?.data?.data?.checksDetails?.[index-1]?.case_check_id);
  }

  const getPrevTab = (id) => {
    let index;
    Object.values(address.checksDetails).map((item,idx) => {
      if(item.case_check_id == id){
        index = idx;
      }
    })
    return index;
  }


  const addAddressStoreData = useSelector((state) => state.addressAdd);
  const { addressAddData, loading: addLoad, error: addError } = addAddressStoreData;
  const [addressAddedState, setAddressAddedState] = useState();



  //on add handler initiate loader
  useEffect(() => {
    if (typeof addLoad !== "undefined" && addLoad !== null) {
      if (addLoad === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        //     reRenderAgain2();
      }

    }
  }, [addressAddData]);


  //after add handler modify existing main state
  useEffect(() => {
    if (
      typeof addressAddData.data !== "undefined" &&
      addressAddData.data !== null
    ) {

      // const newAddress = { ...address };
      // newAddress['checksDetails'][addressAddData.data.checksCount - 1] = addressAddData.data.checksDetails[0];
      // setAddress(newAddress);
      // setAddressAddedState(1);
      dispatch(getData());
      reSetData();
      // console.log("navigation here 414...")
      navigate(
        `/case-initiation/check-detail/${reference}/2/${addressAddData?.data?.checksDetails?.[0]?.case_check_id}`
      );

      reRenderAgain2();


    }

  }, [addressAddData]);

  const addAddressNewStoreData = useSelector((state) => state.addressAddNewCheck);
  const { addressAddNewData, loading: addNewLoad, error: addNewError } = addAddressNewStoreData;

  //on add handler initiate loader
  useEffect(() => {
    if (typeof addNewLoad !== "undefined" && addNewLoad !== null) {
      if (addNewLoad === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        //     reRenderAgain2();
      }

    }
  }, [addressAddNewData]);


  //after add handler modify existing main state
  useEffect(() => {
    if (
      typeof addressAddNewData.data !== "undefined" &&
      addressAddNewData.data !== null
    ) {
      // const newAddress = { ...address };
      // newAddress['checksDetails'][addressAddData.data.checksCount - 1] = addressAddData.data.checksDetails[0];
      // setAddress(newAddress);
      // setAddressAddedState(1);
      dispatch(getData());
      reSetData();
      // console.log("navigation here 414...")
      navigate(
        `/case-initiation/check-detail/${reference}/2/${addressAddNewData?.data?.case_check_id}`
      );

      reRenderAgain2();
      dispatch(deleteAddNewAddress());      
    }

  }, [addressAddNewData]);

  //cheking if any status is not completed
  const [catchIfAnyStatusIsNotCompleted, setCatchIfAnyStatusIsNotCompleted] = useState(0);
  useEffect(() => {
    if (
      typeof address.checksDetails !== "undefined" &&
      address.checksDetails !== null
    ) {
      setCatchIfAnyStatusIsNotCompleted(0);
      Object.entries(address.checksDetails).map(([key, value]) => {
        if (value.check_status != 2) {
          setCatchIfAnyStatusIsNotCompleted(1);
        }

      });
    }
  }, [address]);


  const [checkStatus, setCheckStatus] = useState(0);
  useEffect(() => {
    if ( typeof address.checksDetails !== "undefined" && address.checksDetails !== null) {
      Object.entries(address.checksDetails).map(([key, value]) => {
        if (value.check_status != 2) {
          setCheckStatus(1);
        }
      });
    }
  }, [address]);

  return (
    <>
      {isLoading && <Loader />}
      <NotificationPanels />
      {role == "EP" ? <ClientHeader /> : <Header />}
      {role == "EP" ? <ClientSideBar /> : <Sidebar />}
      {/* <Header />
      <Sidebar /> */}

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              {/* <CandidateTabClient activeTab={"Address"} /> */}
              <CandidateTab
                activeTab={"Address"}
                addFlag={isAddFlag}
                deleteFlag={isDeleteFlag}
                profileFlag={address.showProfilePreview}
              />
            </div>
            <div className="col bg-gray-mbl">
              {/* <br /> */}
              {/*Form*/}
              {/* <form
                ref={form}
                className="p-3 form2 form-section"
                style={{ minHeight: "700px" }}
              > */}

              <form
                className="p-3 form2 form-section"
                style={{ minHeight: "700px" }}
              >
                <div className="d-flex justify-content-between align-items-center flex-column-mbl flex-start-mbl">
                  <div>
                    <StepCount activeTab={"Address"} />
                    <h2 className="fnt-smi-bld">Address Details</h2>
                    {/* <p className="text-muted">For last 7 years details message should reflect below address details.</p> */}
                   {address?.is_new_address_form == 0 && <p className="text-muted">
                      {address?.address_config_msg ||
                        address?.criminal_config_msg}
                    </p>}
                  </div>
                  
                  {/* commenting this as per new form requirement */}
                  {/* {catchIfAnyStatusIsNotCompleted === 0 && */}
                  {address.is_custom_address == 1 && showQuestion == "" && address?.is_new_address_form == 0 && (
                    <button
                      className="btn btn-primary add-btn"
                      style={{ minWidth: "155" + "px" }}
                      onClick={(e) => handleAddressAddClick(e)}
                    >
                      + Add Address
                    </button>
                  )}
                </div>

                {showQuestion == "1" && (
                  <QuestionForm
                    questionStatus={questionStausHandler}
                    questionTitle={questionTitle}
                  />
                )}

                {showQuestion == '' &&
                address?.is_new_address_form == 0 &&

                  <MainForm edu={address} reRenderAgain={reRenderAgain} reRenderAgain2={reRenderAgain2} active={activeTab} showPermanentQues={showPermanentQues} showProfilePreview={showProfilePreview} reference={reference} showPermanentQuesOptions={showPermanentQuesOptions} countries={countryOptions} showAddPopup={showAddPopup} deleteCheckCallback={deleteCheckCallback}
                  closeAddPopup={closeAddPopup}
                  proceedAdd={proceedAdd} checkStatus={checkStatus} reSetData={reSetData} setLastRecordData={setLastRecordData} lastRecordData={lastRecordData}/>
                }

                {showQuestion == "" && (
                  address?.is_new_address_form == 1 &&

                  <NewAddressForm
                    edu={address}
                    reRenderAgain={reRenderAgain}
                    reRenderAgain2={reRenderAgain2}
                    active={activeTab}
                    showPermanentQues={showPermanentQues}
                    showProfilePreview={showProfilePreview}
                    reference={reference}
                    showPermanentQuesOptions={showPermanentQuesOptions}
                    countries={countryOptions}
                    showAddPopup={showAddPopup}
                    deleteCheckCallback={deleteCheckCallback}
                    closeAddPopup={closeAddPopup}
                    proceedAdd={proceedAdd}
                    checkStatus={checkStatus}
                    reSetData={reSetData}
                    setLastRecordData={setLastRecordData}
                    lastRecordData={lastRecordData}
                    proceedAddPostValidation={proceedAddPostValidation}
                    isActive={isActive}
                    setIsActive={setIsActive}
                    setIsDeleteFlag={setIsDeleteFlag}
                    setIsAddFlag={setIsAddFlag}
                  />
                )}

                {/* </form> */}

                {/*Form*/}
                {/* <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    <button className="btn btn-primary btn-lg mr-3">
                      Submit for Preview
                    </button>
                    <span className="text-muted">
                      Please complete the all mandatory fields before final
                      submission
                    </span>
                  </div>
                </div>
              </div> */}
              </form>
              <Footer />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Address;
